import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";

import walkwayDesign from "../../../assets/img/before-after-paver-patio.jpg";
import walkwayExample from "../../../assets/img/elegant-paver-walkway-installation.jpg";
import walkwayExample1 from "../../../assets/img/projects/pavingStone/paving-stone-driveway-elegant-design.jpg";

export default function WalkwayInstallationBlog() {
  const location = useLocation();

  // Meta Tag changes (same as before)
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Professional Walkway Installation Services in Greater Vancouver | BUR-HAN";
    document.title = newTitle;

    const newDescription = "Expert walkway installation services in Vancouver. We design and install durable, beautiful pathways using pavers and natural stone to enhance your property's curb appeal and functionality.";
    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
 "walkway installation Vancouver",
  "paver walkway design",
  "how to build a stone path",
  "garden walkway construction",
  "sidewalk and path installation",
  "paving stone walkway ideas",
  "landscape path design Vancouver",
  "walkway repair services BC"    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost walkwayInstallation">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                Walkway Installation Services
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                Enhance Your Property with Beautiful, Durable Pathways
                <br />
                Serving Greater Vancouver
              </div>
            </h1>
            <p className="lead" data-aos="fade-right"></p>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              At BUR-HAN Garden & Lawn Care, we specialize in designing and installing walkways that combine functionality with aesthetic appeal. A well-designed walkway does more than just connect point A to point B—it enhances your property's curb appeal, improves safety, and adds significant value to your home or business.
            </p>
            <img loading="lazy"
              src={walkwayDesign}
              alt="Professional walkway installation by BUR-HAN in Greater Vancouver"
              title="Custom walkway design and installation in North Vancouver"
              width={"90% !important"}
            />
            <p>
              <span>Why Choose Professional Walkway Installation?</span>
              <br />
              Many homeowners underestimate the complexity of proper walkway installation. In the Pacific Northwest's rainy climate, improper installation can lead to:
            </p>
            <ul>
              <li>Poor drainage and water pooling</li>
              <li>Uneven surfaces that become tripping hazards</li>
              <li>Shifting and settling over time</li>
              <li>Weed growth between pavers</li>
            </ul>
            <p>
              Our professional installation process addresses all these issues from the start. We begin with proper site preparation, including:
            </p>
            <ul>
              <li>Precise grading for optimal water runoff</li>
              <li>Compacted base layers for stability</li>
              <li>Edge restraints to prevent shifting</li>
              <li>Quality materials that withstand our climate</li>
            </ul>
            <p>
              <span>Material Options for Your Walkway</span>
              <br />
              We work with a variety of high-quality materials to suit your style and budget:
            </p>
            <ul>
              <li><strong>Concrete Pavers:</strong> Durable, low-maintenance, and available in numerous colors and patterns. Perfect for modern or traditional landscapes.</li>
              <li><strong>Natural Stone:</strong> Flagstone, slate, or granite for a timeless, elegant look. Each piece is unique, creating a one-of-a-kind pathway.</li>
              <li><strong>Brick:</strong> Classic charm with excellent durability. Ideal for traditional or historic home styles.</li>
              <li><strong>Permeable Options:</strong> Eco-friendly solutions that allow water to drain through, reducing runoff.</li>
            </ul>
           
            <p>
              <span>Our Walkway Installation Process</span>
          
            <ol>
              <li><strong>Consultation & Design:</strong> We discuss your needs, preferences, and budget to create a custom design.</li>
              <li><strong>Site Preparation:</strong> Proper excavation, grading, and base preparation ensure long-lasting results.</li>
              <li><strong>Material Selection:</strong> We help you choose the perfect materials for your style and usage needs.</li>
              <li><strong>Precise Installation:</strong> Our experienced team installs your walkway with attention to every detail.</li>
              <li><strong>Finishing Touches:</strong> Joint sand, sealing (if needed), and cleanup complete the project.</li>
              <li><strong>Final Inspection:</strong> We walk you through the completed project to ensure your complete satisfaction.</li>
            </ol>
            <img loading="lazy"
              src={walkwayExample}
              alt="Completed walkway installation example in West Vancouver"
              title="Beautiful stone walkway installation by BUR-HAN"
              width={"90% !important"}
            />
            </p>
            <p>
              <span>Commercial & Residential Services</span>
              <br />
              Whether you need an inviting front entrance for your business or a charming garden path at your home, we have the expertise to deliver exceptional results. Our commercial walkway installations prioritize durability and safety, while our residential projects focus on blending beauty with functionality.
              <br /><br />
              With over 30 years serving Greater Vancouver, we understand the unique challenges of our local climate and terrain. Our walkways are built to last through rainy winters and sunny summers alike.
            </p>
            <img loading="lazy"
              src={walkwayExample1}
              alt="Completed walkway installation example in West Vancouver"
              title="Beautiful stone walkway installation by BUR-HAN"
              width={"90% !important"}
            />
            <p>
              <span>Service Areas</span>
              <br />
              We proudly serve all of Greater Vancouver, including:
            </p>
            <ul className="service-areas">
              <li>Vancouver</li>
              <li>North Vancouver</li>
              <li>West Vancouver</li>
              <li>Burnaby</li>
              <li>Coquitlam/Port Coquitlam</li>
              <li>Port Moody</li>
              <li>Pitt Meadows/Maple Ridge</li>
              <li>Richmond</li>
              <li>Surrey</li>
              <li>White Rock</li>
            </ul>
            <p>
              Ready to transform your property with a beautiful, functional walkway? Contact us today for a free consultation and estimate.
            </p>
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/expert-walkway-installation-in-greater-vancouver-a-complete-guide">Expert Walkway Installation in Greater Vancouver</a></li>
            <li><a href="/blog/paving-stone-quality-and-value">Paving Stone - Quality and Value</a></li>
            <li><a href="/blog/creating-your-outdoor-living-space-in-vancouver">Creating Your Outdoor Living Space in Vancouver</a></li>
          </ul>
        </div>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our contact page, and let our expert landscaping team
                  bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs.
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}